export const environment = {
  production: false,
  enabledChannels: [
    'CARD',
    'TRANSFER',
    'USSD',
    'OPAY',
    'GOOGLE_PAY',
    'PAYATTITUDE',
  ],
  GOOGLE_PAY_ID: 'BCR2DN4TZL3POBI',
  APPLE_PAY_ID: 'PGW-ZP-101',
  initiativeContext: 'dev.zestpayment.com',
  BASE_URL: 'https://api.dev.gateway.zestpayment.com/payment-engine',
  VAS_SOCKET_URL: 'https://api.dev.gateway.zestpayment.com/virtual-account',
  debug: true,
  txnQueryTime: 60, // 20 minutes
};
